import { LINK_PATTERNS } from "./constants";

export const containsLinks = (text: string): boolean => {
  return LINK_PATTERNS.some((pattern) => {
    pattern.lastIndex = 0;
    return pattern.test(text);
  });
};

export const removeLinks = (text: string): string => {
  let cleanText = text;
  LINK_PATTERNS.forEach((pattern) => {
    pattern.lastIndex = 0;
    cleanText = cleanText.replace(pattern, "[LINK REMOVED]");
  });
  return cleanText;
};
